// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__RFawa","content":"LayoutSettings_content__1EtyQ"};